import React from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import Button from '../components/Button'
import InfoBox from '../components/InfoBox'
import PageLayout from '../components/PageLayout'

interface FeedbackPageProps {
  emoji?: string
  image?: string
  /** Arbitrary hero content rendered above the heading. Takes priority over emoji/image. */
  heroContent?: React.ReactNode
  heading: React.ReactNode | string
  text?: React.ReactNode | string
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export default function FeedbackPage({
  emoji,
  image,
  heroContent,
  heading,
  text,
  onSubmit,
}: FeedbackPageProps) {
  const { t } = useTranslation()

  return (
    <PageLayout>
      <div className="flex grow flex-col text-center">
        <div className="flex grow flex-col items-center justify-center">
          {heroContent ? (
            heroContent
          ) : emoji ? (
            <span className="text-[100px]">{emoji}</span>
          ) : image ? (
            <img src={image} alt="Feedback" className="h-80 w-full sm:w-100" />
          ) : null}

          <h1 className="custom-heading my-5 text-3xl">{heading}</h1>

          {text && (
            <InfoBox>
              <p className="text-center text-base">{text}</p>
            </InfoBox>
          )}
        </div>

        <Form className="shrink-0" method="post" onSubmit={onSubmit}>
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue"
          />
        </Form>
      </div>
    </PageLayout>
  )
}
